<template>
  <div>
    <el-dialog :visible.sync="dialogVisible" @close="closeDialog" slot="title">
      <template slot="title">
        <div>
          <h3>{{title}}</h3>
          <el-divider style="font-weight: bold"></el-divider>
        </div>
      </template>
      <el-form
        :inline="true"
        :model="entity"
        class="demo-form-inline"
        label-width="150px"
        :rules="editFormRules"
        ref="editFormRef"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="Email:" prop="email">
              <el-input
                v-model="entity.email"
                placeholder="Please enter the email"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Account:" prop="loginAccount">
              <el-input
                v-model="entity.loginAccount"
                placeholder="Please enter the account"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="First name:" prop="firstName">
              <el-input
                v-model="entity.firstName"
                placeholder="Please enter the first name"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="Last name:" prop="lastName">
              <el-input
                v-model="entity.lastName"
                placeholder="Please enter the Last name"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="Role permisssion:" prop="roleCode">
        
               <el-select  v-model="entity.roleCode" placeholder="please select permission">
                <el-option  v-for="item in roleList"
                  :key="item.role_code"
                  :label="item.role_name"
                  :value="item.role_code">
                </el-option>
              </el-select>

            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="Phone number:" prop="mobile">
              <el-input
                v-model="entity.mobile"
                placeholder="Please enter the Phone number"
              ></el-input>
            </el-form-item>
          </el-col>

          <!-- <el-col :span="12">
            <el-form-item label="Status">
              <el-input v-model="entity.status" placeholder="Please enter the Status"></el-input>
            </el-form-item>
          </el-col> -->
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">Cancel</el-button>
        <el-button type="primary" @click="save">Save</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

import passinput from '@/components/passInput/PassInput.vue'

export default {
  components: {
    passinput
  },
  props: {
    dialogTableVisible: {
      type: Boolean,
      default() {
        return false
      },
    },
    agentId:{
      default:''
    },
    title:{
      type:String,
      default(){
        return 'Add Employee Account'
      }
    }
  },
  data() {
    return {
      entity: {
        status: 1
      },
      dialogVisible: this.dialogTableVisible,
        //角色列表
      roleList:[],
      // 添加表单的验证规则对象
      editFormRules: {
        email: [
          { required: true, message: 'Email is required', trigger: 'blur' },
          {
            type: 'email',
            trigger: 'blur',
          },
        ],
        loginAccount: [
          { required: true, message: 'login account is required', trigger: 'blur' },
        ],
        firstName: [
          {
            required: true,
            message: 'First name is required',
            trigger: 'blur',
          },
        ],
        lastName: [
          { required: true, message: 'Last name is required', trigger: 'blur' },
        ],
        roleCode: [
          { required: true, message: 'Role permission is required', trigger: 'blur' },
        ],

        
      },
    }
  },
   created(){
      console.log("companyId:"+this.companyId)
    },
  methods: {

    closeDialog() {
      this.entity = {
        status: 1
      }
      this.$emit('closeDialog')
    },
    //传递用户ID
    setUserId(id){

      this.$get(`agent/getEmployee/${id}`).then(({ data: res }) => {
        console.log(res)
        this.entity = res.data
      })

    },
      // 点击按钮保存
    save() {
        console.log('agentId',this.agentId)
      this.$refs.editFormRef.validate(async (valid) => {
        this.entity.companyId = this.agentId
        if (!valid) return

         const loading = this.$loading({
          lock: true,
          text: 'saving ...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        this.$post('agent/saveEmployee', this.entity).then(({ data: res }) => {
          loading.close()
          if (res.ok) {

              this.closeDialog()
            return this.$message.success(res.msg)
            
          } else {
            this.$message.error(res.msg)
          }
          
        }) .catch(err=>{
           loading.close()
        })
      })
    },
  //获取数据字典列表
    getDictList(){
       this.$get(`role/selectByType/AGENT`).then(({ data: res }) => {
        console.log(res)
        this.roleList = res.data
      })
    },
  },
  watch: {
    dialogTableVisible(oldValue, newValue) {
      this.dialogVisible = this.dialogTableVisible

      this.getDictList()
    },
  },
}
</script>

<style>
</style>